import { Button, EmptyState } from '@legalcrm/ui';
import { useNavigate } from 'react-router-dom';

/**
 * An unknown route.
 *
 * Says "not found" and nothing else — deliberately the same wording the API's 404
 * gets. A missing route and a record the reader may not see should read identically,
 * because the backend goes to some trouble to make them indistinguishable and a
 * chattier client-side 404 would undo it.
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="py-16">
      <EmptyState
        title="Not found"
        description="The page you asked for does not exist."
        action={
          <Button variant="secondary" onClick={() => navigate('/')}>
            Back to my day
          </Button>
        }
      />
    </div>
  );
}
